'use client';

import { useEffect } from 'react';

import { createMediaFilter } from '@/actions/media';

type UseCreateMediaFilterParams = {
  imageUrl: string | undefined;
  mediaId: number | undefined;
  filterName: string;
};

export function useCreateMediaFilter({
  imageUrl,
  mediaId,
  filterName,
}: UseCreateMediaFilterParams) {
  useEffect(() => {
    if (imageUrl !== undefined || mediaId === undefined) {
      return;
    }

    void createMediaFilter(mediaId, filterName);
  }, [imageUrl, mediaId, filterName]);
}
